module.exports = __webpack_public_path__ + "img/icon_vehicles.7e4b896.svg";